import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import {
  createConsultantIndustries,
  CreateConsultantIndustriesApiPayload,
} from '@/actions/consultant-industries/createConsultantIndustries';
import { ConsultantIndustries } from '@/types/consultant.type';
import { ApiResponse } from '@/types/response.type';

export interface UseCreateConsultantIndustriesReturn {
  mutate: (
    payload: CreateConsultantIndustriesApiPayload
  ) => Promise<ApiResponse<ConsultantIndustries> | undefined>;
  result: ApiResponse<ConsultantIndustries> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useCreateConsultantIndustries =
  (): UseCreateConsultantIndustriesReturn => {
    const queryClient = useQueryClient();

    const mutation: UseMutationResult<
      ApiResponse<ConsultantIndustries> | undefined,
      Error,
      CreateConsultantIndustriesApiPayload
    > = useMutation({
      mutationFn: createConsultantIndustries,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['consultant-industries'] });
      },
    });

    return {
      mutate: mutation.mutateAsync,
      result: mutation.data,
      error: mutation.error,
      isError: mutation.isError,
      isSuccess: mutation.isSuccess,
      isLoading: mutation.isPending,
    };
  };
